import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Eyebrow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn('text-[13px] font-medium tracking-[0.1em] text-muted uppercase', className)}
    >
      {children}
    </span>
  );
}
